import { startOfWeek, lastDayOfWeek } from 'date-fns';
import { createDateFromString } from 'app/utils/date';

export const isSameWeek = (baseDateString, targetDateString) => {
    const base = createDateFromString(baseDateString);
    const target = createDateFromString(targetDateString);
    const start = startOfWeek(base, { weekStartsOn: 1 });
    const end = lastDayOfWeek(base, { weekStartsOn: 1 });

    return target >= start && target <= end;
};

export const isBannerPeriodActive = (periods, selectedPeriod) => {
    if (!selectedPeriod || !periods?.length) {
        return false;
    }

    return periods.some((periodStart) => isSameWeek(periodStart, selectedPeriod));
};
